module.exports = __webpack_public_path__ + "static/media/jam-bg.bf5848be.png";